"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _spacing = require("@amzn/meridian-tokens/base/spacing");

var _elevation = require("@amzn/meridian-tokens/base/elevation");

var _transitionController = _interopRequireDefault(require("../_transition-controller"));

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _css;

  var state = _ref.state,
      height = _ref.height,
      appearFrom = _ref.appearFrom,
      motionDuration = _ref.motionDuration;
  return (0, _emotion.css)((_css = {
    // Stick the contents of the toast container to the bottom of the container
    // so that when we animate the height of the container the contents appear
    // to undergo a slide animation instead of a reveal animation.
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    "& > *": {
      flexShrink: 0
    },
    // Fade in and out
    opacity: state === "exited" || state === "exiting" ? 0 : 1,
    // Animate the height in and out
    height: state === "exiting" || state === "exited" ? 0 : height
  }, (0, _defineProperty2["default"])(_css, appearFrom === "top" ? "paddingTop" : "paddingBottom", state === "exiting" || state === "exited" ? 0 : _spacing.spacingMedium), (0, _defineProperty2["default"])(_css, "paddingRight", _spacing.spacingMedium), (0, _defineProperty2["default"])(_css, "paddingLeft", _spacing.spacingMedium), (0, _defineProperty2["default"])(_css, "transition", "height ".concat(motionDuration, "ms ease, padding ").concat(motionDuration, "ms ease, opacity ").concat(motionDuration, "ms ease")), (0, _defineProperty2["default"])(_css, "zIndex", state === "exiting" || state === "entering" ? _elevation.elevationBackground : _elevation.elevationForeground), (0, _defineProperty2["default"])(_css, "position", "relative"), _css));
}, ["state", "height", "appearFrom", "motionDuration"]);
/**
 * An internal container that applies toasty animation to its contents.
 */

var Toast = function Toast(_ref2) {
  var children = _ref2.children,
      exit = _ref2.exit,
      motionDuration = _ref2.motionDuration,
      onAfterExit = _ref2.onAfterExit,
      appearFrom = _ref2.appearFrom;
  var ref = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1]; // Open the toast as soon as it's mounted


  (0, _react.useEffect)(function () {
    setOpen(true);
  }, []); // Close the toast when the exit prop flips to true

  (0, _react.useEffect)(function () {
    if (exit) {
      setOpen(false);
    }
  }, [exit]); // Fix the height of the toast before animating (it's the year 2045 and you
  // still can't animate a dynamic height with CSS)

  var onBeforeTransition = (0, _react.useCallback)(function (done) {
    setHeight(ref.current.firstElementChild.getBoundingClientRect().height);
    done();
  }, []); // Unfix the height of the toast after animating it in. This allows the
  // toast's content to change height after mounting without messing anything
  // up.

  var onAfterEnter = (0, _react.useCallback)(function () {
    return setHeight(undefined);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
    "in": open,
    duration: motionDuration,
    onBeforeEnter: onBeforeTransition,
    onBeforeExit: onBeforeTransition,
    onAfterEnter: onAfterEnter,
    onAfterExit: onAfterExit
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: styles({
        state: state,
        height: height,
        appearFrom: appearFrom,
        motionDuration: motionDuration
      }),
      ref: ref
    }, children);
  });
};

Toast.displayName = "Toast";
Toast.propTypes = process.env.NODE_ENV !== "production" ? {
  appearFrom: _propTypes["default"].oneOf(["top", "bottom"]),
  children: _propTypes["default"].node,

  /**
   * Set this to true when the toast is supposed to be unmounted. Doing so will
   * trigger the toast's exit animation, after which it will call the
   * onAfterExit function so that the parent can safely unmount it without
   * interrupting the animation.
   */
  exit: _propTypes["default"].bool,
  motionDuration: _propTypes["default"].number,
  onAfterExit: _propTypes["default"].func
} : {};
Toast.defaultProps = {
  appearFrom: "top",
  motionDuration: 200
};
var _default = Toast;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/toaster/toast.js
// module id = 835
// module chunks = 0